export default __webpack_public_path__ + "static/media/adduser-icon.ef44fdfd.svg";